// extracted by mini-css-extract-plugin
export default {"calendarPanel":"LabMetrics_calendarPanel__n4Bwo","utilizationHeader":"LabMetrics_utilizationHeader__5VNHW","estimatedLabsCell":"LabMetrics_estimatedLabsCell__BKFQw"};